
const MythsAndTruths = () => {
    return (
        <div className='educative-info-section'>
            <div className='educative-container'>
                <header className='educative-header'>
                    <h1 className='educative-main-title'>Mitos y verdades sobre la menstruación</h1>
                    <p className='educative-subtitle'>Conoce la información real para sentirte segura y tranquila</p>
                </header>

                <div className='educative-text-box-container educative-info-textarea' style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <section>
                        <p>
                            A veces se dicen cosas sobre la menstruación que no son ciertas. Es importante conocer la verdad para que te sientas segura
                            y tranquila. Aquí te compartimos algunos mitos y las verdades que debes saber.
                        </p>
                    </section>

                    <section>
                        <h3>Mitos (cosas que no son verdad)</h3>
                        <ul>
                            <li>
                                <strong>“No puedes hacer ejercicio”</strong>: ¡Falso! Puedes moverte, bailar o hacer deporte si te sientes bien.
                                El ejercicio incluso puede ayudarte a sentirte mejor.
                            </li>
                            <li>
                                <strong>“Es algo sucio o vergonzoso”</strong>: ¡Falso! La menstruación es algo natural que le pasa a muchas niñas
                                y mujeres. No hay nada de qué avergonzarse.
                            </li>
                            <li>
                                <strong>“No puedes bañarte”</strong>: ¡Falso! Es muy importante mantenerte limpia durante tu periodo. Puedes bañarte
                                como siempre.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h3>Verdades (cosas que sí son verdad)</h3>
                        <ul>
                            <li>A veces puedes sentir molestias o dolor, pero hay formas de cuidarte para sentirte mejor.</li>
                            <li>Cada cuerpo es diferente: algunas niñas tienen su periodo cada mes, otras no. ¡Y está bien!</li>
                            <li>Hablar sobre la menstruación con alguien de confianza te ayuda a entenderla y a sentirte más tranquila.</li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default MythsAndTruths;